import Axios from "axios";
import {
    SET_PRODUCTION_RAW_MATERIAL_STOCK,
    UNSET_PRODUCTION_RAW_MATERIAL_STOCK,
    SET_PRODUCTION_FINISHED_GOOD_STOCK,
    UNSET_PRODUCTION_FINISHED_GOOD_STOCK,
} from "@/store/mutation-types";
import { 
    productionRawMaterialInventoryList,
    productionFinishedGoodInventoryList,
} from "@/store/api";

const state = {
    productionRawMaterialInventoryList: [],
    productionFinishedGoodInventoryList: [],
};

const getters = {
    productionRawMaterialInventoryList(state) {
        return state.productionRawMaterialInventoryList;
    },
    productionFinishedGoodInventoryList(state) {
        return state.productionFinishedGoodInventoryList;
    },
};

const mutations = {
    [SET_PRODUCTION_RAW_MATERIAL_STOCK](state, data) {
        state.productionRawMaterialInventoryList = data;
    },
    [UNSET_PRODUCTION_RAW_MATERIAL_STOCK](state) {
        state.productionRawMaterialInventoryList = [];
    },

    [SET_PRODUCTION_FINISHED_GOOD_STOCK](state, data) {
        state.productionFinishedGoodInventoryList = data;
    },
    [UNSET_PRODUCTION_FINISHED_GOOD_STOCK](state) {
        state.productionFinishedGoodInventoryList = [];
    },
};

const actions = {

    productionRawMaterialInventoryList({ commit }, params={}) {
        return new Promise((resolve, reject) => {
        Axios.get(productionRawMaterialInventoryList, {params})
            .then(function (response) {
            commit('SET_PRODUCTION_RAW_MATERIAL_STOCK', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PRODUCTION_RAW_MATERIAL_STOCK');
            reject(error);
            });
        });
    },

    productionFinishedGoodInventoryList({ commit }, params={}) {
        return new Promise((resolve, reject) => {
        Axios.get(productionFinishedGoodInventoryList, {params})
            .then(function (response) {
            commit('SET_PRODUCTION_FINISHED_GOOD_STOCK', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PRODUCTION_FINISHED_GOOD_STOCK');
            reject(error);
            });
        });
    },

};

export default {
  state,
  getters,
  actions,
  mutations,
};

